import Surface from "@storeblocks/surface";
import { sharedColors } from "Components/Themes/themesSharedValues";
import styled from "styled-components";

export const CurrentPriceMessageContainer = styled.section`
  align-items: center;

  /* background-color: ${({ theme }) =>
    theme.discountMessage.backgroundColor}; */
  background-color: var(--p-color-static-orange-background);
  border-radius: ${({ theme }) => theme.borderRadius.smallRounding};
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
  color: ${({ theme }) => theme.discountMessage.textColor};
  display: flex;
  flex-direction: row;
  font-size: 16px;
  gap: 16px;
  line-height: 24px;
  margin-top: 10px;
  padding: 16px;
  width: 100%;

  @media screen and (max-width: 482px) {
    > span {
      flex-wrap: wrap;
      margin-right: 55px;
    }
  }
`;

export const PriceDiscountSurface = styled(Surface)`
  border: 3px solid var(--p-color-static-orange-background);
  margin-bottom: var(--spacer-s);
  padding: 16px;
`;

export const ExpandablePriceDiscountButton = styled.div`
  align-items: center;

  /* background-color: ${() => sharedColors.surface.variant}; */
  background-color: var(--p-color-static-orange-background);
  cursor: pointer;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 16px;
`;

export const ExpandablePriceDiscountDetails = styled.div`
  /* border: 3px solid ${() => sharedColors.surface.variant}; */
  border: 3px solid var(--p-color-static-orange-background);
  padding: 16px;
`;
